import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  title: {
    height: 34,
    alignItems: 'flex-end',
    fontWeight: 300
  },
  // Stacks the Update Offer title above its reason subtitle (#30230 follow-up).
  titleContainer: {
    display: 'flex',
    flexDirection: 'column'
  },
  subtitle: {
    alignItems: 'flex-end',
    fontWeight: 400,
    fontSize: 12
  },
  invalidOptionTitle: {
    height: 34,
    fontWeight: 300,
    paddingLeft: theme.spacing(2),
    paddingTop: theme.spacing(1),
    color: theme.colorPalette.white
  },
  invalidOptionSubtitle: {
    paddingLeft: theme.spacing(2)
  },
  footerContainer: {
    height: 98,
    background: theme.colorPalette.beige_50,
    boxShadow: '0px -1px 3px 0px rgba(0,0,0,0.2)'
  },
  extendedFooterContainer: {
    height: 180,
    background: theme.colorPalette.beige_50,
    boxShadow: '0px -1px 3px 0px rgba(0,0,0,0.2)',
    padding: theme.spacing(8, 30, 0),
    alignContent: 'center',
    justifyContent: 'space-between'
  },
  footerRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  scrollButton: {
    padding: theme.spacing(1.5, 4)
  },
  footerAlert: {
    background: theme.colorPalette.orange_50
  },
  floatingContainer: {
    position: 'fixed',
    left: 0,
    width: '100%',
    bottom: 0,
    zIndex: 150
  },
  footerContainerWithBanner: {
    height: 'unset'
  },
  footerContent: {
    display: 'grid',
    gridTemplateColumns: '1fr auto',
    width: '100%',
    maxWidth: 1280,
    height: 98,
    margin: theme.spacing(0, 'auto')
  },
  btn: {
    padding: theme.spacing(0, 6),
    width: 260
  },
  wideBtn: {
    padding: theme.spacing(0, 6),
    width: 320
  },
  btnIcon: {
    marginRight: theme.spacing(1),
    height: 24,
    width: 24
  },
  btnLabel: {
    fontWeight: 600,
    fontSize: 16
  },
  form: {
    display: 'flex',
    marginRight: theme.spacing(6)
  },
  formBtn: {
    backgroundColor: theme.colorPalette.orange_50,
    minWidth: 164,
    '&.MuiButton-contained.Mui-disabled': {
      color: theme.colorPalette.white,
      backgroundColor: theme.colorPalette.orange_50_op_70
    }
  },
  emailBtnLabel: {
    fontWeight: 500,
    fontSize: 14,
    paddingLeft: theme.spacing(0.5)
  },
  emailField: {
    paddingRight: theme.spacing(3),
    minHeight: 67
  },
  checkbox: {
    paddingRight: theme.spacing(3)
  },
  updateActions: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(4)
  },
  troubleshootingLabel: {
    paddingTop: theme.spacing(4)
  },
  // Keep the toggle from butting up against the adjacent footer button
  troubleshootingToggle: {
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(4)
  },
  tooltipContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(3),
    marginTop: theme.spacing(1)
  },
  tooltip: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1)
  },
  tooltipText: {
    fontSize: 14,
    fontWeight: 600,
    lineHeight: '20px',
    color: theme.colorPalette.orange_50,
    opacity: '60%'
  },
  copyLinksContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  sharingOptionsButton: {
    color: theme.colorPalette.orange_50,
    fontSize: 16,
    fontWeight: 600,
    lineHeight: '24px',
    textTransform: 'none',
    gap: theme.spacing(1)
  },
  copyLinkIcons: {
    marginRight: theme.spacing(1)
  },
  editIcon: {
    width: 24,
    height: 24
  },
  editContainer: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(2),
    gap: theme.spacing(2)
  },
  viewMoreButton: {
    height: 10
  },
  buttons: {
    padding: '0px 30px',
    marginRight: 20,
    marginBottom: 20
  },
  notificationContent: {
    color: 'black'
  },
  buttonContainer: {
    marginTop: 20
  },
  mainLabel: {
    margin: '20px 0px 10px 0px'
  },
  subLabel: {
    margin: '15px 20px 4px 0px '
  },
  aqdUpdateButton: {
    width: 186,
    marginLeft: 16
  },
  sentToUnderwritingBanner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 6,
    width: '100%',
    height: 32,
    backgroundColor: theme.colorPalette.beige_60
  },
  approvedBanner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 6,
    width: '100%',
    height: 32,
    backgroundColor: theme.colorPalette.green_75_10
  },
  approvedDangerBanner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 6,
    width: '100%',
    height: 32,
    backgroundColor: theme.colorPalette.orange_75
  },
  bannerAlertIcon: {
    height: 14
  },
  sentToUnderwritingText: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '20px',
    color: theme.colorPalette.green_90
  },
  approvedDangerBannerText: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '20px',
    color: theme.colorPalette.white
  },
  modalContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    padding: theme.spacing(6)
  },
  modalActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(1),
    padding: theme.spacing(6)
  },
  shareIcon: {
    paddingRight: theme.spacing(2)
  },
  btnLoadingMessage: {
    width: 'auto',
    minWidth: 260
  },
  aqdUpdateButtonLoadingMessage: {
    width: 'auto',
    minWidth: 186
  }
}));

export default useStyles;
